import { environment } from '../../../environments/environment';
import { HttpClient, } from '@angular/common/http';
// import { BSessionStorage } from '../service/bSessionStorage.service';
import 'rxjs/add/operator/toPromise';
import { SystemService } from '../../service/system.service';
import { BSessionStorage } from '../../service/bSessionStorage.service';
import { BLocalStorageService } from '../../service/bLocalStorage.service';
import { BAppService } from '../../service/bApp.service';
import { PubSubService } from '../../service/pubSub.service';
var dashboardService = (function () {
    function dashboardService(http, bAppService, pubSub) {
        this.http = http;
        this.bAppService = bAppService;
        this.pubSub = pubSub;
        this.dashboardObj = {};
        this.url = '';
        this.uuid = '';
        this.fbregid = '';
        var systemService = new SystemService();
        this.bSessionStorage = new BSessionStorage();
        this.bLocalStorage = new BLocalStorageService();
        this.uuid = this.bLocalStorage.getValue('uuid');
        this.fbregid = this.bLocalStorage.getValue('registrationId');
        if (environment && environment.properties) {
            this.url = systemService.getAppUrl();
        }
    }
    Object.defineProperty(dashboardService.prototype, "dashboardObject", {
        get: function () {
            if (this.dashboardObj)
                return this.dashboardObj;
            // return {};
        },
        set: function (dashboardObj) {
            if (dashboardObj)
                this.dashboardObj = dashboardObj;
        },
        enumerable: true,
        configurable: true
    });
    // getDashboards() {
    //   const url = `${this.url}notification/getDashboards`;
    //   return this.http.post(url, null).subscribe(result => console.log(result));
    // }
    dashboardService.prototype.getDashboards = function () {
        var _this = this;
        var url = this.url + "notification/getDashboards";
        return this.http.post(url, null)
            .toPromise()
            .then(function (response) {
            if (response) {
                _this.dashboardObj = response;
            }
            return _this.dashboardObj;
        })
            .catch(function (reason) {
            console.error(reason);
            // return reason;
        });
    };
    dashboardService.prototype.updateDashboards = function (dashboard) {
        var _this = this;
        var url = this.url + "notification/updateDashboards";
        var userObj = this.bSessionStorage.getValue('userObj');
        var userAccountObj = {
            "uuid": this.uuid,
            "fbregid": this.fbregid,
            "bUserAccount": userObj
        };
        var sendObj = {
            dashboard: dashboard,
            userAccountObj: userAccountObj
        };
        this.dashboardObj = { dashboard: dashboard };
        return this.http.post(url, sendObj)
            .toPromise()
            .then(function (response) {
            // this.dashboardObject = dashboard;
            _this.pubSub.$pub('dashBoadrd', response);
            _this.bAppService.openSnackBar("Dashboards saved");
            return dashboard;
        })
            .catch(function (reason) {
            console.error(reason);
        });
    };
    return dashboardService;
}());
export { dashboardService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/dashboard/dashboard.service.ts.pre-build-optimizer.js